<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <!-- <div class="navbar-bookmarks flex items-center">
          <ul class="vx-navbar__starred-pages">
            <div class="flex cursor-move">
              <li class="starred-page" v-for="page in starredPagesLimited" :key="page.id">
                <vx-tooltip :text="page.title" position="bottom" color="primary">
                  <feather-icon :svgClasses="['h-6 w-6 stroke-current', textColor]" class="p-2 cursor-pointer" :icon="page.icon" @click="execMethod(page.action)" />
                </vx-tooltip>
              </li>
            </div>
          </ul>
        </div> -->

        <template v-if="roleGeneralData.showTopOptions">
          <p v-if="roleGeneralData.status" class="info-border-inline-nav ml-3 bold">{{roleGeneralData.status}}</p>
          <p v-if="roleGeneralData.days && topOptionsVisible" class="info-border-inline-nav ml-3 bold">{{roleGeneralData.days}}</p>
          <p v-if="roleGeneralData.amountDue && dueAmountVisible" class="info-border-inline-nav ml-3 bold">{{roleGeneralData.amountDue}}</p>
          <vs-button v-if="roleGeneralData.textButton && topOptionsVisible" color="primary" class="ml-3" @click="goToRealizarPagoPage">{{roleGeneralData.textButton}}</vs-button>
        </template>

        <vs-spacer />
        <notification-drop-down v-if="showNotifs"/>
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>


<script>
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import {mapState} from "vuex";

const navIconsDefinitions = [
  { id: 2, title: "Dinos qué opinas", icon: "ThumbsUpIcon", action: "showFeedback" },
];

export default {
  name: 'applicant-navbar-vertical',
  data (){
    return {
      showNotifs: false,
      starredPagesLimited: navIconsDefinitions,
      offsetTopOptions: 1000,
      offsetDueAmount: 650,
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    NotificationDropDown,
    ProfileDropDown
  },
  computed: {
    ...mapState("auth", ["roleGeneralData"]),
    navbarColorLocal () {
      if(this.$store.state.theme === 'rg-semi-dark'){
        return "";
      }
      else {        
        return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
      }

    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    topOptionsVisible () {
      return this.$store.state.windowWidth > this.calcOffset(this.offsetTopOptions);
    },
    dueAmountVisible () {
      return this.$store.state.windowWidth > this.calcOffset(this.offsetDueAmount);
    },
    showChip(){
      return false;
    },
    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    },
  },
  methods: {
    calcOffset(base){
      return (this.showChip) ? (base + this.offsetTopOptions) : base;
    },
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    showCalendar(){
      this.$store.commit('TOGGLE_IS_CALENDAR_POPUP_ACTIVE', true)
    },
    showFeedback(){
      this.$store.commit('TOGGLE_IS_FEEDBACK_POPUP_ACTIVE', true)
    },
    showGeneralLog(){
      this.$store.commit('TOGGLE_IS_GENERAL_LOG_POPUP_ACTIVE', true)
    },
    execMethod(method){
      this[method]();
    },
    async goToRealizarPagoPage(){
      await this.$router.push({name: 'realizarPagosSolicitante'});
    }
  }
}
</script>

